import React, { useEffect, useRef, useState, Dispatch, SetStateAction, KeyboardEvent } from 'react';
import Stack from '@mui/material/Stack/Stack';

interface PinInputProps {
  pin: string;
  onChange: Dispatch<SetStateAction<string>>;
}

export const PinInput: React.FC<PinInputProps> = ({ pin, onChange }) => {
  const [values, setValues] = useState<string[]>(['', '', '', '']);
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  useEffect(() => {
    const pinArray = pin.split('').slice(0, 4);
    setValues([pinArray[0] || '', pinArray[1] || '', pinArray[2] || '', pinArray[3] || '']);
  }, [pin]);

  const updatePin = (newValues: string[]) => {
    setValues(newValues);
    onChange(newValues.join(''));
  };

  const handleChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) return;

    const newValues = [...values];
    newValues[index] = value;
    updatePin(newValues);

    if (value && index < 3) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace') {
      if (values[index] === '') {
        if (index > 0) {
          const newValues = [...values];
          newValues[index - 1] = '';
          updatePin(newValues);
          inputsRef.current[index - 1]?.focus();
        }
      } else {
        const newValues = [...values];
        newValues[index] = '';
        updatePin(newValues);
      }
    }
  };

  return (
    <Stack direction="row" spacing={2}>
      {values.map((digit, index) => (
        <input
          key={index}
          type="password"
          inputMode="numeric"
          autoFocus={index === 0}
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputsRef.current[index] = el)}
          style={{
            width: '40px',
            height: '50px',
            fontSize: '24px',
            textAlign: 'center',
            border: '1px solid #ccc',
            borderRadius: '6px',
            background: 'var(--color-element)',
            color: 'var(--color-type-primary)',
          }}
        />
      ))}
    </Stack>
  );
};
